//Built-In
import React, {Fragment} from 'react';
import {formatDate, getSiteURL} from "../Common/Appcommon";

//External
//Internal
 class Footer extends React.Component{
    constructor(props) {
        super(props);
        let pageTitle = props.pageTitle;
        this.state = {
            active: pageTitle,
        };
    }

    render(){

        let title = this.state.active;
        const year = formatDate(new Date(),"yyyy");
        const siteURL = getSiteURL();
        return (
            <></>
            // <Fragment>
            //     <div className="footer">
            //         <span className='footer-bar'>© {year}, <a href={siteURL} className='footerlink' target={'_blank'}>Cratio CRM.</a></span>
            //     </div>
            // </Fragment>
        )
    }
}

export default Footer;
